export default {
  namespaced: true,
  state: {
    loading: false,
    productsUseUniquePrice: [],
    productsUniquePrice: []
  },
  actions: {
    updateIfProductUseUniquePrice ({ state, commit }, product) {
      commit('setLoading', true)

      const variationPriceToCompare = product.variations[0].price
      const useUniquePrice = product.variations.length === product.variations
        .filter(
          variation =>
            variation.price.type === variationPriceToCompare.type &&
            variation.price.previous === variationPriceToCompare.previous &&
            variation.price.current === variationPriceToCompare.current &&
            variation.price.auxiliary === variationPriceToCompare.auxiliary
        ).length

      if (useUniquePrice) {
        commit('addProduct', product.productId)
        return
      }

      commit('removeProduct', product.productId)
    },
    updatePriceByProductId ({ state, commit }, { productId, price }) {
      commit('updatePrice', { productId, price })
    },
    addProduct ({ state, commit }, product) {
      commit('addProduct', product.productId)
    },
    removeProduct ({ state, commit }, product) {
      commit('removeProduct', product.productId)
    }
  },
  getters: {
    isUseUniquePrice: state => productId => state.productsUseUniquePrice.indexOf(productId) !== -1,
    getProductUniquePrice: state => productId => state.productsUniquePrice.find(product => product.id === productId)
  },
  mutations: {
    setLoading (state, flag) {
      state.loading = flag
    },
    addProduct (state, productId) {
      if (state.productsUseUniquePrice.indexOf(productId) === -1) {
        state.productsUseUniquePrice.push(productId)
      }

      state.loading = false
    },
    removeProduct (state, productId) {
      const productIds = []

      for (let i in state.productsUseUniquePrice) {
        const product = state.productsUseUniquePrice[i]

        if (product === productId) {
          continue
        }

        productIds.push(product)
      }

      state.productsUseUniquePrice = productIds

      state.loading = false
    },
    updatePrice (state, { productId, price }) {
      const product = state.productsUniquePrice.find(product => product.id === productId)
      if (product !== undefined) {
        product.price = price
      } else {
        state.productsUniquePrice.push({
          id: productId,
          price: price
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/panel/editPrices.js